import React from 'react';
import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import styles from './IconCard.module.scss';

const IconCard = ({ icon, title, description, curveType, curveClass }) => {
  return (
    <Box className={styles.cardWrapper}>
      <Box className={styles.iconRow}>
        <div className={styles.iconCurveContainer}>
          <div>
            <Box className={styles.iconBox}>
              <Image src={icon} alt={title} width={64} height={64} />
            </Box>
          </div>

          {/* Show connector if provided */}
          {curveType && (
            <Box className={`${styles.curveWrapper} ${curveClass}`}>
              {curveType}
            </Box>
          )}
        </div>
      </Box>

      <Box className={styles.textBlock}>
        <Typography
          variant="p1"
          color="primary.black"
          className={styles.cardTitle}
        >
          {title}
        </Typography>
        <Typography variant="p1-book" className={styles.cardDescription}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default IconCard;
